import { gql } from '@apollo/client'

export const BUSINESS_UNITS_TREE_UPDATE_MUTATION = gql`
  mutation BUSINESS_UNITS_TREE_UPDATE_MUTATION($businessUnits: [BusinessUnitsTreeUpdateInput]!) {
    businessUnitsTreeUpdate(businessUnits: $businessUnits) {
      ok
    }
  }
`

export const BUSINESS_UNIT_DELETE_MUTATION = gql`
  mutation BUSINESS_UNITS_DELETE_MUTATION($id: ID!) {
    businessUnitDelete(id: $id) {
      ok
    }
  }
`

export const BUSINESS_UNIT_UPDATE_MUTATION = gql`
  mutation BUSINESS_UNIT_UPDATE_MUTATION($id: ID!, $businessUnit: BusinessUnitUpdateInput!) {
    businessUnitUpdate(id: $id, businessUnit: $businessUnit) {
      ok
    }
  }
`

export const BUSINESS_UNIT_CREATE_MUTATION = gql`
  mutation BUSINESS_UNIT_CREATE_MUTATION($businessUnit: BusinessUnitCreateInput!) {
    businessUnitCreate(businessUnit: $businessUnit) {
      ok
    }
  }
`

export const BUSINESS_UNITS_BULK_IMPORT_MUTATION = gql`
  mutation BUSINESS_UNITS_BULK_IMPORT_MUTATION($input: BusinessUnitsBulkImportInput!) {
    businessUnitsBulkImport(input: $input) {
      ok
      message
    }
  }
`
